import React from 'react'
import { useActions, useValues } from 'kea'

import I18n from 'lib/i18n'

import sceneLogic from '~/scenes/pages/request/logic'

const Email = () => {
  const { setEmail } = useActions(sceneLogic)
  const { email, errors } = useValues(sceneLogic)

  const handleChangeEmail = event => setEmail(event.target.value)

  return (
    <div className={`form-element full-width${errors.email ? ' has-errors' : ''}`}>
      <label htmlFor='change-email-input' className='block'>
        {I18n.t('react.request.request.email')}
      </label>
      <input
        id='change-email-input'
        type='text'
        value={email}
        className='input-text inline'
        onChange={handleChangeEmail}
      />
      {errors.email && <div className='simple-error'>{errors.email}</div>}
    </div>
  )
}

export default Email
